import Config from "../config";
import {getConfigurationResponseDummy} from "./mocks";
import {get} from "../util/network.util";


export async function getConfiguration() {
    if (Config.use_dummy) return getConfigurationResponseDummy;
    return await get(`/v1/configuration`);
}